import type { introspection } from "../shop-api.generated"

import { initGraphQLTada } from "gql.tada"

export const graphql = initGraphQLTada<{
  introspection: introspection
  scalars: {
    Money: number
  }
}>()

export type { FragmentOf, ResultOf, VariablesOf } from "gql.tada"
export { readFragment } from "gql.tada"
